var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-2 {\n        isolation: isolate;\n        opacity: .5;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21,3.36C11.26,3.36,3.36,11.26,3.36,21s7.9,17.64,17.64,17.64,17.64-7.9,17.64-17.64S30.74,3.36,21,3.36h0M21,32.62c-6.41,0-11.62-5.2-11.62-11.61s5.2-11.62,11.61-11.62,11.62,5.2,11.62,11.61h0c0,6.41-5.2,11.62-11.61,11.62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "cls-2",
    d: "M21,0C9.4,0,0,9.4,0,21s9.4,21,21,21,21-9.4,21-21S32.6,0,21,0M21,34.83c-7.64,0-13.82-6.19-13.82-13.83,0-7.64,6.19-13.82,13.83-13.82,7.64,0,13.82,6.19,13.82,13.82s-6.19,13.83-13.82,13.83h0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.d535f46e.svg";
export { ForwardRef as ReactComponent };